/**
 * Created by pmnia on 27/03/15.
 */

//source:https://github.com/angular-ui/bootstrap/issues/2828
(function () {
    'use strict';
    angular
        .module('app.widgets')
        .config(['$uibTooltipProvider', function($uibTooltipProvider) {
            $uibTooltipProvider.options({animation: false});
        }])
        // .config(['$tooltipProvider', function($tooltipProvider) {
        //     $tooltipProvider.options({animation: false});
        // }])
        // Bootstrap UI fixes after upgrading to Angular 1.3
        .directive('tooltipHtmlUnsafe', function() {
            return {
                restrict: 'EA',
                link: function(scope, element, attrs) {
                    attrs.tooltipPlacement = attrs.tooltipPlacement || 'top';
                    attrs.tooltipAnimation = attrs.tooltipAnimation || true;
                    attrs.tooltipPopupDelay = attrs.tooltipPopupDelay || 0;
                    attrs.tooltipTrigger = attrs.tooltipTrigger || 'mouseenter';
                    attrs.tooltipAppendToBody = attrs.tooltipAppendToBody || false;
                }
            }
        })

        .directive('popover', function() {
            return {
                restrict: 'EA',
                link: function(scope, element, attrs) {
                    attrs.popoverPlacement = attrs.popoverPlacement || 'top';
                    attrs.popoverAnimation = attrs.popoverAnimation || true;
                    attrs.popoverPopupDelay = attrs.popoverPopupDelay || 0;
                    attrs.popoverTrigger = attrs.popoverTrigger || 'mouseenter';
                    attrs.popoverAppendToBody = attrs.popoverAppendToBody || false;
                }
            }
        })

})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/ui-bootstrap.directives.fix.js
 ** module id = 177
 ** module chunks = 0
 **/